import { render, staticRenderFns } from "./changeFields.vue?vue&type=template&id=e18c9872&scoped=true"
import script from "./changeFields.vue?vue&type=script&lang=js"
export * from "./changeFields.vue?vue&type=script&lang=js"
import style0 from "./changeFields.vue?vue&type=style&index=0&id=e18c9872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18c9872",
  null
  
)

export default component.exports